import { Typography } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import features from '~/constants/features';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import LeftLayout from '~/layouts/LeftLayout';
import WizardContent from '~/layouts/WizardContent';
import { SuccessfulOnboardingImg } from '~/img';
import CompletionContainer from '~/pages/ksa/completion/components/CompletionContainer';

const AgentCompletedOnboarding: FC = () => {
  const { t } = useTranslation('ksaCompletion');

  return (
    // <WizardContent
    //   left={
    //     <LeftLayout>
    //       <BottomLeftActions contactUsUrl={features.contactUsLinkHardDecline} />
    //     </LeftLayout>
    //   }
    //   content={
    <CompletionContainer>
      <Typography.Title>
        {t('Congratulations!')}
        <br />
        {t('This Merchant has been onboarded.')}
      </Typography.Title>
      <SuccessfulOnboardingImg className="Completion-Img" />
    </CompletionContainer>
    //   }
    //   right={null}
    // />
  );
};

export default AgentCompletedOnboarding;
